// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__1hK-U","cell":"ColumnAccessor_cell__gWMtm","firstCellAccent":"ColumnAccessor_firstCellAccent__CGLNL"};